// @flow
import { styled } from 'mz-ui-kit'
import { getScreenStyles } from 'mz-ui-kit/utils'

export const Container = styled('div', {
  display: 'flex',
  flexFlow: 'column nowrap',
})

export const FieldContainer = styled<{}>('div', ({ $palette }) => ({
  display: 'flex',
  padding: '10px',
  border: `1px solid ${$palette('gray')}`,
  borderRadius: '3px',
  ...getScreenStyles(
    'xs',
    {
      flexFlow: 'column nowrap',
    },
    {
      flexFlow: 'row nowrap',
      alignItems: 'center',
    }
  ),
}))

export const EstimatedNote = styled<{}>('div', ({ $palette }) => ({
  marginTop: '-4px',
  borderRadius: '0 0 3px 3px',
  background: `${$palette('gray')}`,
  padding: '10px',
}))

export const IconWrapper = styled<{}>('div', ({ $palette }) => ({
  color: `${$palette('primary')}`,
  fontSize: '1.5rem',
  marginRight: '10px',
}))

export const SelectWrapper = styled('div', {
  flexGrow: 1,
  ...getScreenStyles('xs', null, {
    marginLeft: '10px',
    marginTop: '-8px',
  }),
})

export const AdjustedTime = styled<{
  $currColor?: boolean,
}>('span', ({ $currColor, $palette }) => ({
  color: $currColor ? 'currentColor' : `${$palette('primary')}`,
  fontWeight: 600,
  flexGrow: 1,
}))

export const ExactTime = styled<{
  $currColor?: boolean,
}>('span', ({ $currColor, $palette }) => ({
  color: $currColor ? 'currentColor' : `${$palette('primary')}`,
  fontWeight: 300,
  whiteSpace: 'nowrap',
}))

export const Label = styled('div', {
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  whiteSpace: 'nowrap',
})
